<dx-popup
  [width]="520"
  [height]="'auto'"
  [showTitle]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  class="modal"
  [wrapperAttr]="{ 
    class: 'confirmation-dialog-modal' 
  }"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="dismiss()"
>
  <div *dxTemplate="let data of 'content'" class="modal-content">
    @if(isCompliance) {
      <div class="modal-title">
        {{ 'MANAGE-ELEARNING.DETAIL.COMPLETE-COMPLIANCE-COURSE-DIALOG.TITLE' | translate }}
      </div>
      <div class="modal-text">
        <p>{{ 'MANAGE-ELEARNING.DETAIL.COMPLETE-COMPLIANCE-COURSE-DIALOG.TEXT-1' | translate }}</p>
        <p>{{ 'MANAGE-ELEARNING.DETAIL.COMPLETE-COMPLIANCE-COURSE-DIALOG.TEXT-2' | translate }}</p>
      </div>
    } @else {
      <div class="modal-title">
        {{ 'MANAGE-ELEARNING.DETAIL.COMPLETE-COURSE-DIALOG.TITLE' | translate }}
      </div>
      <div class="modal-text">
        <p>{{ 'MANAGE-ELEARNING.DETAIL.COMPLETE-COURSE-DIALOG.TEXT-1' | translate }}</p>
        <p>{{ 'MANAGE-ELEARNING.DETAIL.COMPLETE-COURSE-DIALOG.TEXT-2' | translate }}</p>
      </div>
    }
  </div>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{
      type: 'default',
      text: 'COMMON.CANCEL' | translate,
      onClick: dismiss
    }"
  ></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      stylingMode: 'contained',
      text: 'COMMON.CONFIRM' | translate,
      onClick: onSubmit
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>
